import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { LanguageApiService } from '@doc/api/server-bo';
import { BehaviorSubject } from 'rxjs'; // Import BehaviorSubject

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public languages: string[] = ['en', 'ar'];
  private languageApiService = inject(LanguageApiService);
  
  // Create a BehaviorSubject to hold the current language
  private currentLanguageSubject = new BehaviorSubject<string>('en');
  public currentLanguage$ = this.currentLanguageSubject.asObservable(); // Expose as observable

  constructor(public translate: TranslateService, private cookieService: CookieService) {
    this.translate.addLangs(this.languages);
    this.getLanguagefromStore();
    this.setLanguage(this.getLanguagefromStore());
  }

  public setLanguage(lang: string) {
    this.translate.use(lang);
    this.languageManagement(lang);
    this.currentLanguageSubject.next(lang); // Notify all subscribers about the language change
  }

  languageManagement(lang: any) {
    if (lang === 'ar') {
      document.querySelector('html')?.setAttribute('dir', 'rtl');
      document.querySelector('html')?.setAttribute('lang', 'ar');

    }
    else {
      document.querySelector('html')?.setAttribute('dir', 'ltr');
      document.querySelector('html')?.setAttribute('lang', 'en');
    }
  }
  getLanguagefromStore(){
    let language = localStorage.getItem('lang') || 'en';
    return language;
  }
 
  toggleLanguage() {
    let language = localStorage.getItem('lang') || 'en';
    let newLang = language === 'en' ? 'ar' : 'en';
    this.languageManagement(newLang);
    localStorage.setItem('lang', newLang);
    this.setLanguage(newLang);
    return newLang;
  }
    toggleLanguageKd(incolang) {
    let language = localStorage.getItem('lang') || 'en';
    // let newLang = language === 'en' ? 'ar' : 'en';
    this.languageManagement(incolang);
    localStorage.setItem('lang', incolang);
    this.setLanguage(incolang);
    return incolang;
  }

}
